import { map, pathOr, compose } from 'ramda';

import API from 'app/api';
import { LATEST_NEWS_LIMIT } from 'app/features/news/constants';
import parseResponse from 'app/api/requests/parsers/response';
import { News } from 'app/api/entities/news';
import logError from 'app/error/logError';

const fetchLatestNews = () =>
  API.Content.fetchLatestNews({
    latest_news_n: LATEST_NEWS_LIMIT,
    top_news_n: 0,
  })
    .then(parseResponse)
    .then(compose(map(News), pathOr([], ['latest_news', 'items'])))
    .catch(logError);

export { fetchLatestNews };
